module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAASdJREFUOE/lkzFKxEAUht8/CXiBFdwY0WILO1sLhXgLAwFBI2HRI1hs4REUCUZBCMRbGNDC1s7CYsVsVnAvIEzmyaykWMgmKbYRp5ph3nw//z/vgRa0sCAO/RFQ6FqdIMknVbbn3c1Yu9pf2VgSYoth9ARYvmfZ5SAlqYEDh8x12z7Re1Zq+K3US//+c1iKzYCuPdsxCA/E/KzA56Lg7mGSR7r41rV8ZWAsGGcEbBfEe8dxltaDtCqzJMIFSE0tMokOEZ8CMPW5NaipLf4r6Mbt7sAwH5vymYZfyN2jZPxU+Wu6V9asVQ8CB0RwqoGcsuK7j3wUlz2m6+bOWuham6YwAiL2f4GIpCrCIMlfqwQahzbylnv6oR9/vdVZbgS1yavWWltAWfcDz6qDE82qEWgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/version.png
// module id = Edmg
// module chunks = 1